import styled from 'styled-components';
import { Colors } from 'modules/utils';

export const PrintableAccordion = styled.div`
	margin-bottom: 10px;

	&:first-child {
		page-break-inside: auto;
	}

	&:last-child {
		margin-bottom: 0;
	}

	span > span {
		font-weight: 700;
	}

	.table__footer {
		font-size: 14px;
	}
`;

export const PrintableAccordionHeader = styled.div`
	border: 1px solid ${Colors.LIGHT_GREY};
	min-height: 50px;
	padding: 0 0 0 15px;

	${({ fullBorder }) =>
		!fullBorder &&
		`
		border-bottom: 0;
	`};
`;
